import styled from 'styled-components';


export default styled.div`
  font-size: 1.4em;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;


// WEBPACK FOOTER //
// ./src/components/share/ErrorMessage.js